<template lang="pug">
header.navbar
  section.navbar-section.breadcrumb-section
    breadcrumb(:breadcrumb="breadcrumb" :params="params")
  section.navbar-section.avatar-section
    navbar-user
</template>

<script>
import NavbarUser from './NavbarUser'
import Breadcrumb from './Breadcrumb'

export default {
  props: {
    breadcrumb: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },

  components: { NavbarUser, Breadcrumb },
}
</script>

<style lang="stylus">
@import '../../styles/_colors.styl'
.navbar
  display flex
  background-color sidebar-background
  color primary
  padding 0 30px 0 0
  height 55px
  .breadcrumb-section
    flex 1
  .avatar-section
    flex 0
  a.c-hand.text-error.tooltip.tooltip-left
    margin-bottom 2px
    padding 0 10px
  .petis-logo
    margin-left 5px
    font-size 1rem
    align-self center
  .petis
    margin-right 80px
    font-weight 600
    padding 10px
    white-space nowrap
    text-transform uppercase
    letter-spacing .05em
  .avatar.avatar-lg
    width 2rem
    height 2rem
    font-size 1rem
    border solid 1px primary
  .shutdown
    color primary
</style>
